import { useQuery } from 'react-query';

import { getVoicesSeats } from '@/services/api';
import { useAuth } from '@/services/auth';
import { logger } from '@/services/logger';

export const GET_VOICES_SEATS_KEY = 'get-voices-seats';

const fetch = (isAnonymous: boolean) => async () => (!isAnonymous ? await getVoicesSeats() : 0);

export function useGetVoicesSeats() {
    const { isAnonymous } = useAuth();

    return useQuery(GET_VOICES_SEATS_KEY, fetch(!!isAnonymous), {
        refetchOnWindowFocus: false,
        refetchOnMount: false,

        onError: error => {
            logger.error('failed to get voices seats', { error });
        },
    });
}
